import { render, staticRenderFns } from "./specialCourses.vue?vue&type=template&id=568793cd&scoped=true&"
import script from "./specialCourses.vue?vue&type=script&lang=js&"
export * from "./specialCourses.vue?vue&type=script&lang=js&"
import style0 from "./specialCourses.vue?vue&type=style&index=0&id=568793cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568793cd",
  null
  
)

export default component.exports